import { getConfig } from '../config/configService';
import { FETCH } from '../components/Fetch/middleware';

export const CHECKIN = '@TEXT2APPLY/CHECKIN';
export const NEXT = '@TEXT2APPLY/NEXT';
export const IDSCANREQUEST = '@TEXT2APPLY/IDSCANREQUEST';
export const UPLOADTOPRESIGNEDURLREQUEST = '@TEXT2APPLY/UPLOADTOPRESIGNEDURLREQUEST';
export const GET_KEY = '@TEXT2APPLY/GET_KEY';
// ID scan workflows
export const IDASTART = '@TEXT2APPLY/IDASTART';
export const IDANEXT = '@TEXT2APPLY/IDANEXT';
export const MANUAL_PAYMENT = '@TEXT2APPLY/MANUAL_PAYMENT';
export const CHECK_PAYMENT = '@TEXT2APPLY/CHECK_PAYMENT';
export const GET_IP_ADDRESS = '@TEXT2APPLY/GET_IP_ADDRESS';
// VERIFICATON workflows
export const NEW_CHECKIN = '@TEXT2APPLY/NEW_CHECKIN';
export const NEW_START = '@TEXT2APPLY/NEW_START';
export const NEW_NEXT = '@TEXT2APPLY/NEW_NEXT';
export const RANDOM_NEXT = '@TEXT2APPLY/RANDOM_NEXT';
export const NEW_RANDOM_NEXT = '@TEXT2APPLY/NEW_RANDOM_NEXT';
export const LAST_NEXT = '@TEXT2APPLY/LAST_NEXT';
export const NEW_LAST_NEXT = '@TEXT2APPLY/NEW_LAST_NEXT';
export const SET_TEST_SUBJECT = '@TEXT2APPLY/SET_TEST_SUBJECT';
export const RESUME_APPLICATION = '@TEXT2APPLY/RESUME_APPLICATION';
export const VALIDATE_BANK_ROUTING_NUMBER = '@TEXT2APPLY/VALIDATE_BANK_ROUTING_NUMBER';

// t2a workflows
export const checkinAction = (payload) => {
  const config = getConfig();
  return {
    type: CHECKIN,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? payload.rawUrl : `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/checkin`,
      onUploadProgress: payload.onUploadProgress,
      data: payload.data,
      success: payload.success,
      fail: payload.fail,
    },
  };
};

export const nextAction = (payload) => {
  const config = getConfig();
  return {
    type: NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? `${config.navigationUrl}${payload.rawUrl}` : `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const randomNextAction = (payload) => {
  const config = getConfig();
  return {
    type: RANDOM_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? `${config.navigationUrl}${payload.rawUrl}` : `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const lastNextAction = (payload) => {
  const config = getConfig();
  return {
    type: LAST_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? `${config.navigationUrl}${payload.rawUrl}` : `${config.navigationUrl}/${payload.entityType}/${payload.entityId}/workflow/${payload.workflowType}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

// new workflows
export const newCheckInAction = (payload) => {
  const config = getConfig();
  return {
    type: NEW_CHECKIN,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? payload.rawUrl : `${config.navigationUrl}/${payload.workflowType}/${payload.key}/checkin`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
    },
  };
};

export const newNextAction = (payload) => {
  const config = getConfig();
  return {
    type: NEW_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? `${config.navigationUrl}${payload.rawUrl}` : `${config.navigationUrl}/${payload.workflowType}/${payload.key}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const newRandomNextAction = (payload) => {
  const config = getConfig();
  return {
    type: NEW_RANDOM_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? `${config.navigationUrl}${payload.rawUrl}` : `${config.navigationUrl}/${payload.workflowType}/${payload.key}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const newLastNextAction = (payload) => {
  const config = getConfig();
  return {
    type: NEW_LAST_NEXT,
    [FETCH]: {
      method: 'PUT',
      url: payload.rawUrl ? `${config.navigationUrl}${payload.rawUrl}` : `${config.navigationUrl}/${payload.workflowType}/${payload.key}/next`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
      'Content-Encoding': 'gzip',
    },
  };
};

export const uploadImageToPreSignedUrlAction = (payload) => ({
  type: UPLOADTOPRESIGNEDURLREQUEST,
  [FETCH]: {
    method: 'PUT',
    url: payload.data.url,
    data: payload.data.imageData,
    headers: {
      'Content-Type': 'image/*',
    },
    onUploadProgress: payload.onUploadProgress,
    success: payload.success,
    fail: payload.fail,
  },
});

export const idScanRequestAction = (payload) => {
  const config = getConfig();
  return {
    type: IDSCANREQUEST,
    [FETCH]: {
      method: 'POST',
      url: `${config.idScanUrl}/request/`,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        Authorization: `Bearer ${config.idScanPubKey}`,
      },
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
      success: payload.success,
      fail: payload.fail,
    },
  };
};

export const idaStartAction = (payload) => {
  const config = getConfig();
  return {
    type: IDASTART,
    [FETCH]: {
      method: 'POST',
      url: `${config.navigationUrl}/${payload.workflowType}/start`,
      data: payload.data,
    },
  };
};

export const idaNextAction = (payload) => {
  const config = getConfig();
  return {
    type: IDANEXT,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/next`,
      data: payload.data,
    },
  };
};

export const manualPaymentAction = (payload) => {
  const config = getConfig();
  return {
    type: MANUAL_PAYMENT,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/step/PaymentManual`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
    },
  };
};

export const checkPaymentAction = (payload) => {
  const config = getConfig();
  return {
    type: CHECK_PAYMENT,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/step/PaymentCheck`,
      data: payload.data,
      onUploadProgress: payload.onUploadProgress,
    },
  };
};

export const getIPAddress = (payload) => ({
  type: GET_IP_ADDRESS,
  [FETCH]: {
    method: 'GET',
    url: 'https://api.ipify.org?format=json&callback=?',
    success: payload.success,
    nullData: true,
  },
});

export const getKeyAction = (payload) => {
  const config = getConfig();
  return {
    type: GET_KEY,
    [FETCH]: {
      method: 'GET',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.entityType}/${payload.entityId}/workflow/key`,
      success: payload.success,
    },
  };
};

export const resumeApplication = (payload) => {
  const config = getConfig();
  return {
    type: RESUME_APPLICATION,
    [FETCH]: {
      method: 'PUT',
      url: `${config.navigationUrl}/${payload.workflowType}/${payload.key}/step/continuefromcreditfreeze`,
      success: payload.success,
      fail: payload.fail,
      data: payload.data,
    },
  };
};

export const validateBankRoutingNumberAction = (payload) => {
  const config = getConfig();
  return {
    type: VALIDATE_BANK_ROUTING_NUMBER,
    [FETCH]: {
      method: 'GET',
      url: `${config.navigationUrl}/helpers/bank-account/routing-number/${payload.routingNumber}`,
      success: payload.success,
      fail: payload.fail,
    },
  };
};
